<div #root class="support-editor" tabindex="-1" data-test-id="support-editor">
  <div class="support-editor-toolbar" role="toolbar">
    <button
      eBtn
      size="sm"
      type="button"
      icon="crop"
      [color]="mode() === 'crop' ? 'primary-75' : undefined"
      [class.is-active]="mode() === 'crop'"
      [attr.aria-pressed]="mode() === 'crop'"
      (click)="setMode('crop')"
      data-test-id="support-editor-crop"
    >
      {{ 'support.editor.crop' | transloco }}
    </button>
    <button
      eBtn
      size="sm"
      type="button"
      icon="square-dashed"
      [color]="mode() === 'mark' ? 'primary-75' : undefined"
      [class.is-active]="mode() === 'mark'"
      [attr.aria-pressed]="mode() === 'mark'"
      (click)="setMode('mark')"
      data-test-id="support-editor-mark"
    >
      {{ 'support.editor.mark' | transloco }}
    </button>
    <button
      eBtn
      size="sm"
      type="button"
      icon="arrow-up-right"
      [color]="mode() === 'arrow' ? 'primary-75' : undefined"
      [class.is-active]="mode() === 'arrow'"
      [attr.aria-pressed]="mode() === 'arrow'"
      (click)="setMode('arrow')"
      data-test-id="support-editor-arrow"
    >
      {{ 'support.editor.arrow' | transloco }}
    </button>
    <button
      eBtn
      size="sm"
      type="button"
      icon="reply"
      [disabled]="annotations().length === 0"
      (click)="undo()"
      data-test-id="support-editor-undo"
    >
      {{ 'support.editor.undo' | transloco }}
    </button>
    <button eBtn size="sm" type="button" icon="rotate-left" (click)="reset()" data-test-id="support-editor-reset">
      {{ 'support.editor.reset' | transloco }}
    </button>
  </div>

  <p class="support-editor-help">{{ 'support.editor.help' | transloco }}</p>

  <div class="support-editor-stage" [class.is-mark]="mode() !== 'crop'" [class.is-ready]="ready()">
    <canvas #imageCanvas class="support-editor-image" role="img" [attr.aria-label]="'support.editor.canvas' | transloco"></canvas>
    <canvas
      #overlayCanvas
      class="support-editor-overlay"
      role="img"
      [attr.aria-label]="'support.editor.canvas' | transloco"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerCancel()"
      data-test-id="support-editor-overlay"
    ></canvas>
    @if (cropView(); as view) {
      <div
        class="support-editor-crop"
        [class.is-interactive]="mode() === 'crop'"
        [style.left.px]="view.x"
        [style.top.px]="view.y"
        [style.width.px]="view.width"
        [style.height.px]="view.height"
        (pointerdown)="onCropPointerDown($event)"
        (pointermove)="onCropPointerMove($event)"
        (pointerup)="onCropPointerUp($event)"
        (pointercancel)="onCropPointerCancel($event)"
        data-test-id="support-editor-crop-frame"
      >
        @for (handle of handles; track handle) {
          <div class="support-editor-handle" [attr.data-handle]="handle" [style.cursor]="handleCursor(handle)"></div>
        }
        <span class="support-editor-size" [class.is-inside]="sizeLabelInside()" data-test-id="support-editor-crop-size">{{ cropLabel() }}</span>
      </div>
    }
  </div>

  <div class="support-editor-actions">
    <button eBtn size="sm" type="button" icon="xmark" (click)="cancel()" data-test-id="support-editor-cancel">
      {{ 'support.editor.cancel' | transloco }}
    </button>
    <button eBtn size="sm" type="button" icon="check" color="primary" [disabled]="!ready() || busy()" [loading]="busy()" (click)="use()" data-test-id="support-editor-use">
      {{ 'support.editor.use' | transloco }}
    </button>
  </div>
</div>
